// extracted by mini-css-extract-plugin
export default {"backButton":"b7+nQPEYzS29kVa2qinVNA=="};